export default __webpack_public_path__ + "static/media/power.f7e47cdf.svg";